export default __webpack_public_path__ + "static/media/external-link.472d6e13.svg";